var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-record-table"},[_c('Commontable',{attrs:{"tableData":_vm.tableData,"headerData":_vm.headerData,"hasChecked":false},on:{"onRowClick":_vm.onRowClick,"handleSelectionChange":_vm.handleSelectionChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }